export default {
    aiLimit: {
        account: 'Wykorzystano miesięczny limit AI. Odnowi się {date}.',
        app: 'AI jest chwilowo niedostępne. Wróci {date}.',
    },
    actions: {
        cancel: 'Anuluj',
        delete: 'Usuń',
        save: 'Zapisz',
        saving: 'Zapisuję…',
        add: 'Dodaj',
        edit: 'Edytuj',
        close: 'Zamknij',
        back: 'Wstecz',
        next: 'Dalej',
        done: 'Gotowe',
        retry: 'Spróbuj ponownie',
        search: 'Szukaj',
        clear: 'Wyczyść',
        ok: 'OK',
        yes: 'Tak',
        no: 'Nie',
    },
    states: {
        loading: 'Ładuję…',
        saved: 'Zapisane.',
        loadFailed: 'Nie udało się wczytać danych.',
        fetchFailed: 'Nie udało się pobrać danych.',
    },
    confirm: {
        title: 'Usunąć?',
        message: 'Tego nie da się cofnąć.',
        deleting: 'Usuwam…',
        // tam, gdzie po usunięciu jest jeszcze toast z „Cofnij"
        undoable: 'Przez chwilę możesz to jeszcze cofnąć.',
    },
    // Pytania „czy na pewno" z useConfirm — tytuły i opisy skutków.
    confirmAsk: {
        note: 'Usunąć notatkę?',
        noteCategory: 'Usunąć kategorię?',
        noteCategoryNotes: 'Notatka z tej kategorii zostanie bez kategorii. Przez chwilę możesz to jeszcze cofnąć. | {n} notatki zostaną bez kategorii. Przez chwilę możesz to jeszcze cofnąć. | {n} notatek zostanie bez kategorii. Przez chwilę możesz to jeszcze cofnąć.',
        project: 'Usunąć projekt?',
        projectTasks: 'Usunie też jedno zadanie. Przez chwilę możesz to jeszcze cofnąć. | Usunie też {n} zadania. Przez chwilę możesz to jeszcze cofnąć. | Usunie też {n} zadań. Przez chwilę możesz to jeszcze cofnąć.',
        task: 'Usunąć zadanie?',
        section: 'Usunąć sekcję?',
        sectionTasks: 'Jej zadanie przejdzie do zadań bez sekcji. | Jej {n} zadania przejdą do zadań bez sekcji. | Jej {n} zadań przejdzie do zadań bez sekcji.',
        template: 'Usunąć szablon?',
        group: 'Usunąć grupę?',
        groupPeople: 'Osoba z tej grupy zostanie bez grupy. Przez chwilę możesz to jeszcze cofnąć. | {n} osoby zostaną bez grupy. Przez chwilę możesz to jeszcze cofnąć. | {n} osób zostanie bez grupy. Przez chwilę możesz to jeszcze cofnąć.',
        person: 'Usunąć osobę?',
        personData: 'Razem z ważnymi datami, pomysłami na prezent i historią kontaktów. Przez chwilę możesz to jeszcze cofnąć.',
        date: 'Usunąć ważną datę?',
        gift: 'Usunąć pomysł na prezent?',
        contact: 'Usunąć kontakt?',
        pet: 'Usunąć zwierzę?',
        petData: 'Razem z obsługami, pomiarami wagi i dokumentami. Przez chwilę możesz to jeszcze cofnąć.',
        weight: 'Usunąć pomiar wagi?',
        device: 'Usunąć sprzęt?',
        deviceData: 'Razem z obsługami, przebiegiem i dokumentami. Przez chwilę możesz to jeszcze cofnąć.',
        mileage: 'Usunąć wpis przebiegu?',
        care: 'Usunąć obsługę?',
        careLogs: 'Usunie też jedno wykonanie z historii. Przez chwilę możesz to jeszcze cofnąć. | Usunie też {n} wykonania z historii. Przez chwilę możesz to jeszcze cofnąć. | Usunie też {n} wykonań z historii. Przez chwilę możesz to jeszcze cofnąć.',
        careLog: 'Usunąć wykonanie?',
        habit: 'Usunąć nawyk?',
        habitData: 'Razem z całą historią odhaczeń i serią. Jeśli chcesz tylko zrobić przerwę, odłóż go do archiwum.',
        medication: 'Usunąć lek?',
        medicationData: 'Razem z historią wziętych i pominiętych dawek. Jeśli kuracja się skończyła, możesz go odłożyć do archiwum.',
        document: 'Usunąć dokument?',
        workoutType: 'Usunąć rodzaj treningu?',
        targetWeight: 'Usunąć wagę docelową?',
        variant: 'Usunąć wariant?',
        attachment: 'Usunąć załącznik?',
        overpayment: 'Cofnąć nadpłatę?',
        overpaymentMessage: 'Nadpłata zniknie z historii, a kredyt przeliczy się od nowa.',
        undoRecord: 'Usunąć {what}?',
        assistantRecord: 'Usunąć utworzony wpis?',
        basketItem: 'Usunąć z listy?',
        setItem: 'Usunąć z zestawu?',
        cooking: 'Usunąć gotowanie na zapas?',
        googleLogin: 'Odłączyć logowanie przez Google?',
        googleLoginMessage: 'Dalej zalogujesz się e-mailem i hasłem.',
    },
    select: {
        placeholder: 'Wybierz',
        search: 'Szukaj…',
        noMatch: 'Nic nie pasuje.',
    },
    sectionInfo: {
        button: 'Co to?',
        ariaLabel: 'Co to jest: {title}',
    },
    firstSteps: {
        cardHeading: 'PIERWSZE KROKI · {done} Z {total}',
        hide: 'Ukryj',
        all: 'Wszystkie',
        title: 'Pierwsze kroki',
        intro: 'Dodaj swoje pierwsze rzeczy — przy każdej piszemy, czym jest i po co. Zadanie odhaczy się samo.',
        progress: '{done} z {total}',
        notApplicable: 'nie dotyczy',
        why: 'Po co?',
        first: 'Najpierw: {task}.',
        addMore: 'Dodaj kolejne',
        skip: 'Nie dotyczy mnie',
        unskip: 'Jednak dotyczy',
        showOnHome: 'Pokaż na stronie głównej',
        alsoUnderHelp: 'Lista jest też pod „Pomoc" w nagłówku.',
        doneTask: 'Zrobione: {task}',
        nextTask: 'Następne: {task}',
        allDone: 'Pierwsze kroki za Tobą — wszystko gotowe.',
        list: 'Lista',
    },
    tourButton: {
        help: 'Pomoc',
        guide: 'Przewodnik',
        guideHint: 'Co gdzie jest — od tej zakładki',
        firstSteps: 'Pierwsze kroki',
        firstStepsHint: 'Dodaj swoje pierwsze rzeczy i dowiedz się, po co są',
        label: {
            forma: 'Pomoc w Formie',
            portfel: 'Pomoc w Portfelu',
            koszyk: 'Pomoc w Koszyku',
            planer: 'Pomoc w Planerze',
            miejsca: 'Pomoc w Miejscach',
            jedzenie: 'Pomoc w Jedzeniu',
            assistant: 'Pomoc w rozmowie z asystentem',
            notatnik: 'Pomoc w Notatniku',
            projekty: 'Pomoc w Projektach',
            ludzie: 'Pomoc w Ludziach',
            zwierzeta: 'Pomoc w Zwierzętach',
            sprzety: 'Pomoc w Sprzętach',
            nawyki: 'Pomoc w Nawykach',
            leki: 'Pomoc w Lekach',
        },
    },
    tour: {
        gotIt: 'Rozumiem',
        progress: '{current} z {total}',
        next: 'Dalej',
        prev: 'Wstecz',
        done: 'Gotowe',
    },
    errors: {
        saveRetry: 'Nie udało się zapisać. Spróbuj ponownie.',
        deleteFailed: 'Nie udało się usunąć.',
    },
    date: {
        prevMonth: 'Poprzedni miesiąc',
        nextMonth: 'Następny miesiąc',
        openTasks: 'Niezrobione zadania: {n}',
        openTasksDay: '{day}, niezrobione zadania: {n}',
        weekdaysMin: {
            mon: 'p',
            tue: 'w',
            wed: 'ś',
            thu: 'c',
            fri: 'p',
            sat: 's',
            sun: 'n',
        },
        choose: 'Wybierz…',
        today: 'Dziś',
        yesterday: 'Wczoraj',
        tomorrow: 'Jutro',
        now: 'Teraz',
        hour: 'Godzina',
        weekdaysShort: {
            mon: 'Pn',
            tue: 'Wt',
            wed: 'Śr',
            thu: 'Cz',
            fri: 'Pt',
            sat: 'So',
            sun: 'Nd',
        },
    },
    amount: {
        portionMode: 'Wpisujesz porcje (1 {portion} = {weight} g) — kliknij, aby wpisać gramy',
        gramMode: 'Wpisujesz gramy — kliknij, aby wpisać porcje (1 {portion} = {weight} g)',
        unitToggle: 'Jednostka: {unit}. Przełącz',
    },
    barcode: {
        title: 'Skanuj kod',
        hint: 'Skieruj kamerę na kod kreskowy produktu.',
        noPermission: 'Brak zgody na kamerę. Wpisz kod ręcznie albo zmień uprawnienia w przeglądarce.',
        cameraFailed: 'Nie udało się uruchomić kamery. Wpisz kod ręcznie.',
        manual: 'Albo wpisz kod ręcznie',
        placeholder: 'np. 5901234123457',
    },
    record: {
        editPrefix: 'Edytuj',
        deleteNamed: 'Usunąć {name}?',
        required: 'To pole jest wymagane',
        scanFill: 'Skanuj kod kreskowy i wypełnij pola',
        scanProduct: 'Skanuj kod kreskowy produktu',
        shrink: 'Zmniejsz okno',
        expand: 'Powiększ okno',
        tabError: 'Błąd w tej zakładce',
        searchProduct: 'Szukaj produktu',
        timePlaceholder: 'np. 9:30',
        codeNotInOff: 'Kodu {code} nie ma w Open Food Facts — wpisz produkt ręcznie.',
        codeNotInCatalogue: 'Kodu {code} nie ma w katalogu produktów.',
        codeCheckFailed: 'Nie udało się sprawdzić kodu. Spróbuj ponownie.',
        checkingCode: 'Sprawdzam kod…',
        offSearch: 'Szukaj po nazwie w Open Food Facts',
        searching: 'Szukam…',
        offNotFound: 'Nie znaleziono „{query}" — uzupełnij dane ręcznie.',
        offFailed: 'Nie udało się połączyć z Open Food Facts.',
        offFilled: 'Dane uzupełnione — sprawdź je i dopisz cenę.',
        assistLabel: 'Uzupełnij dane AI',
        askingAi: 'Pytam AI…',
        assistEmpty: 'Nie udało się nic oszacować.',
        assistDone: 'Dane uzupełnione — sprawdź je przed zapisem.',
        assistFailed: 'Nie udało się uzupełnić danych.',
    },
    time: {
        now: 'Teraz · {time}',
        formatHint: 'np. 9:30, 930, 21',
    },
};
